/* @flow */
import { Observable } from 'rxjs';
import { combineEpics, ActionsObservable } from 'redux-observable';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:router:epics'); // eslint-disable-line no-unused-vars

import { LOCATION_CHANGE } from './action-types';
import * as App from 'modules/app';
import * as Search from 'modules/search';
import * as Report from 'modules/reports';
import * as Analysis from 'modules/analysis';
import { toggleShowEntireSummary } from 'modules/summaries/actions';
import { resetBreadcrumbs } from 'modules/constellation/actions';
import { fetch as fetchUsers } from '../users/actions';
import { userListPopulated } from '../users/getters';
import { setLastRoute } from '../app/actions';

const DISPATCH_SEARCH_AFTER_CLEAR = true;
/* NOTE: Respond to routing events with various actions.
 * Regrettably, the pathname is the only information we can
 * get from react-router-redux, the full pathname, w/out
 * the route id or query params. */
const navigationEpic = (action$: ActionsObservable<*>, store) =>
  action$.ofType(LOCATION_CHANGE).mergeMap(({ payload }) => {
    /* *******************************************************
     * Build up actions[] based on different routing conditions
     ******************************************************** */
    const actions = [];

    const {
      pathname: path,
      query: { q: searchQuery },
      action
    } = payload;

    const state = store.getState();
    const visited = state.getIn(['app', 'activity']);
    /* *******************************************************
     * Record route history
     ******************************************************** */
    actions.push(setLastRoute(path));

    /* *******************************************************
     * Handle explore route:
     ******************************************************** */
    if (path.includes('browse')) {
      if (!visited.get('visitedExplore')) {
        actions.push(App.actions.setActivity({ visitedExplore: true }));
      }
    }

    /* *******************************************************
     * Handle cases route:
     ******************************************************** */
    if (path.includes('browse/cases')) {
      actions.push(Analysis.actions.fetchAll());
    }

    /* *******************************************************
     * Handle search route:
     ******************************************************** */
    if (path.includes('browse/search')) {
      const existingSearch = Search.getters.searchTerm(state);

      /* One-time focus search bar! */
      if (!searchQuery && !existingSearch) {
        const searchInput = document.getElementById('@@_Search_Bazr');
        if (searchInput) searchInput.focus();
      }

      /* Run search! It happens here (also, search does not "refresh") */
      if (searchQuery && searchQuery !== existingSearch) {
        // If we are loading the site with a search query, don't want to clear reports or ioc filters
        actions.push(
          App.actions.setActivity({
            visitedEntities: true,
            visitedReports: true
          })
        );
        actions.push(Search.actions.executeSearch(searchQuery));
      }
    }
    /* *******************************************************
     * Handle Report route:
     ******************************************************** */
    if (path.includes('browse/reports')) {
      if (!visited.get('visitedReports')) {
        actions.push(
          App.actions.setActivity({
            visitedEntities: true,
            visitedReports: true
          })
        );
        actions.push(
          Search.actions.clearReportFilters(DISPATCH_SEARCH_AFTER_CLEAR)
        );
      }
    }
    /* *******************************************************
     * Handle IOC route:
     ******************************************************** */
    if (path.includes('browse/iocs')) {
      if (!visited.get('visitedEntities')) {
        actions.push(
          App.actions.setActivity({
            visitedEntities: true,
            visitedReports: true
          })
        );
        actions.push(
          Search.actions.clearEntityFilters(DISPATCH_SEARCH_AFTER_CLEAR)
        );
      }
    }
    /* *******************************************************
     * Handle constellation route:
     ******************************************************** */

    if (path.includes('constellation')) {
      // If we have not fetched the user's list yet -- do so now. Reports, Cases and IOCs need the user list for auto suggestions in notes.
      if (!userListPopulated(state)) {
        actions.push(fetchUsers());
      }
      // Collapse the summary, reset breadcrumbs
      actions.push(toggleShowEntireSummary({ show: false }));
      actions.push(resetBreadcrumbs());
    }

    if (path.includes('constellation/reports')) {
      const reportId = path.split('reports/')[1]; // HMMM
      actions.push(Report.actions.setCurrentReportId(reportId));
      if (!visited.get('visitedConstellation')) {
        actions.push(App.actions.setActivity({ visitedConstellation: true }));
      }
    }

    return actions;
  });

export default combineEpics(navigationEpic);



// WEBPACK FOOTER //
// ./src/app/modules/router/epics.js